import { Draft, PayloadAction } from "@reduxjs/toolkit";
import { CurriculumState } from "../../../curriculum-slice";
import dayjs from "dayjs";

export const updateComponentContentAction = (
  state: Draft<CurriculumState>,
  action: PayloadAction<{
    componentId: number;
    content: string;
    apiHandled?: boolean;
  }>,
) => {
  const { componentId, content } = action.payload;
  const component = state.value.components[componentId];
  if (!component) return;

  state.value.components[componentId] = {
    ...component,
    content: content,
    draftExist: true,
    updatedAt: dayjs(),
  };
};
